const sideCard = document.querySelector('.aside-wrap');
const desktop = window.matchMedia('(min-width: 768px)');
let scheduled = false;

function positionSideCard() {
  scheduled = false;
  if (!desktop.matches) {
    sideCard.style.removeProperty('--side-card-top');
    sideCard.style.removeProperty('width');
    return;
  }
  sideCard.style.width = `${sideCard.parentElement.clientWidth}px`;
  const viewportHeight = window.innerHeight;
  const cardHeight = sideCard.getBoundingClientRect().height;
  const bottomBar = document.querySelector('.bottom-cta');
  const bottomInset = Math.max(16, bottomBar.getBoundingClientRect().height + 12);
  const centerTop = Math.max(16, (viewportHeight - cardHeight) / 2);
  const initialTop = Math.max(centerTop, viewportHeight - cardHeight - bottomInset);
  const top = Math.max(centerTop, initialTop - Math.max(0, window.scrollY));
  sideCard.style.setProperty('--side-card-top', `${top}px`);
}

function schedulePosition() {
  if (!scheduled) {
    scheduled = true;
    window.requestAnimationFrame(positionSideCard);
  }
}

window.addEventListener('scroll', schedulePosition, { passive: true });
window.addEventListener('resize', schedulePosition);
desktop.addEventListener('change', schedulePosition);
new ResizeObserver(schedulePosition).observe(sideCard);
if (document.fonts) document.fonts.ready.then(schedulePosition);
positionSideCard();

/* Image fallback only: advertorial images have no enlargement controls. */
(() => {
  const init = () => {
    document.querySelectorAll('img[data-full-src]').forEach((image) => {
      const fallback = () => { image.removeAttribute('srcset'); image.src = image.dataset.fullSrc; };
      image.addEventListener('error', fallback, {once:true});
      if (image.complete && !image.naturalWidth) fallback();
    });

  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();

/* Anticipate nearby images without starting the whole mobile article at entry. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  const pending = new Set(document.querySelectorAll('.article img[loading="lazy"]'));
  let observer;
  const observe = (margin) => {
    observer?.disconnect();
    observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target: image, isIntersecting }) => {
        if (!isIntersecting) return;
        image.fetchPriority = 'auto';
        image.loading = 'eager';
        pending.delete(image);
        observer.unobserve(image);
      });
    }, { rootMargin: margin, threshold: 0 });
    pending.forEach((image) => observer.observe(image));
  };
  observe(mobile ? '400px 0px 600px 0px' : '1500px 0px 3500px 0px');
  if (mobile) window.addEventListener('scroll', () => observe('800px 0px 1800px 0px'), { once: true, passive: true });
})();

(() => {
  const rules = [
  [
    "introduction",
    "vous commencez à perdre espoir",
    "strong"
  ],
  [
    "introduction",
    "votre cuir chevelu est plus clairsemé que le mois dernier",
    "strong"
  ],
  [
    "introduction",
    "Voici les 5 raisons",
    "strong"
  ],
  [
    "raison-1",
    "si votre corps était tout simplement… le problème",
    "strong"
  ],
  [
    "raison-1",
    "le follicule, sous votre cuir chevelu",
    "strong"
  ],
  [
    "raison-1",
    "vous ne voyez que la dernière étape du processus",
    "strong"
  ],
  [
    "raison-1",
    "chaque follicule suit un cycle",
    "strong"
  ],
  [
    "raison-2",
    "Le changement commence bien plus tôt, sous votre cuir chevelu.",
    "strong"
  ],
  [
    "raison-2",
    "Cycle après cycle, ils produisent alors des cheveux plus fins, plus courts et moins visibles",
    "strong"
  ],
  [
    "raison-2",
    "la fibre capillaire",
    "strong"
  ],
  [
    "raison-2",
    "qu’est-ce qui a réellement été étudié au niveau du follicule et de la croissance ?",
    "strong"
  ],
  [
    "raison-3",
    "pendant 6 mois",
    "strong"
  ],
  [
    "raison-3",
    "À 3 mois",
    "strong"
  ],
  [
    "raison-3",
    "À 6 mois",
    "strong"
  ],
  [
    "raison-3",
    "Il soutient l’activité du follicule.",
    "strong"
  ],
  [
    "raison-3",
    "Il aide à préserver un environnement favorable à la croissance.",
    "strong"
  ],
  [
    "raison-4",
    "nous avons cessé de faire des compromis sur la qualité",
    "strong"
  ],
  [
    "raison-4",
    "Extrait de romarin",
    "strong"
  ],
  [
    "raison-4",
    "Extrait de coco",
    "strong"
  ],
  [
    "raison-4",
    "Extrait d’argan",
    "strong"
  ],
  [
    "raison-4",
    "Extrait de ricin",
    "strong"
  ],
  [
    "raison-4",
    "Extrait de café vert",
    "strong"
  ],
  [
    "raison-4",
    "Voici le calendrier des changements observés par nos clientes :",
    "strong"
  ],
  [
    "raison-4",
    "Semaine 1 : Moins de cheveux dans votre brosse.",
    "strong"
  ],
  [
    "raison-4",
    "Semaine 2 : Votre cuir chevelu commence à changer.",
    "strong"
  ],
  [
    "raison-4",
    "Semaine 4 : Le déclic. Les petits cheveux qui repoussent.",
    "strong"
  ],
  [
    "raison-4",
    "Semaine 8 : La densité capillaire revient visiblement.",
    "strong"
  ],
  [
    "raison-4",
    "À partir du 3e mois",
    "strong"
  ],
  [
    "raison-4",
    "Un flacon dure environ un mois",
    "strong"
  ],
  [
    "raison-5",
    "Nous élaborons nos formules en petites quantités.",
    "strong"
  ],
  [
    "raison-5",
    "Actuellement, nous avons des flacons disponibles.",
    "strong"
  ],
  [
    "raison-5",
    "vous êtes intégralement remboursé(e)",
    "strong"
  ],
  [
    "raison-5",
    "Vous conservez le reste du produit.",
    "strong"
  ],
  [
    "commande",
    "Étape 1 :",
    "strong"
  ],
  [
    "commande",
    "Étape 2 :",
    "strong"
  ],
  [
    "commande",
    "Étape 3 :",
    "strong"
  ],
  [
    "raison-1",
    "Le véritable changement a commencé bien avant, sous votre cuir chevelu.",
    "u"
  ],
  [
    "raison-1",
    "Ce n’est pas de votre faute.",
    "u"
  ],
  [
    "raison-2",
    "prendre soin de la fibre ne signifie pas agir sur le follicule qui la produit",
    "u"
  ],
  [
    "raison-4",
    "notre formule ne repose pas sur un seul ingrédient",
    "u"
  ],
  [
    "raison-5",
    "une garantie de remboursement de 30 jours",
    "u"
  ],
  [
    "introduction",
    "POURQUOI aucun de ces compléments n'a fonctionné",
    "strong"
  ],
  [
    "raison-1",
    "vos follicules ne sont pas morts.",
    "strong"
  ],
  [
    "raison-1",
    "Vos cheveux sont en manque de nutriments essentiels.",
    "strong"
  ],
  [
    "raison-2",
    "pendant que ses racines s’affaiblissent",
    "strong"
  ],
  [
    "raison-3",
    "aucun des deux groupes ne présentait d’augmentation significative du nombre de cheveux",
    "strong"
  ],
  [
    "raison-3",
    "aucune différence significative n’a été observée entre les deux groupes sur ce critère",
    "strong"
  ],
  [
    "raison-3",
    "là où le cheveu prend naissance",
    "strong"
  ],
  [
    "raison-4",
    "30 % d'extrait de romarin pur",
    "strong"
  ],
  [
    "raison-5",
    "nous ne diluons pas nos produits.",
    "strong"
  ],
  [
    "commande",
    "expédition sous 24 h, livraison sous 9 à 11 jours ouvrés",
    "strong"
  ],
  [
    "raison-3",
    "Il relance la croissance des follicules au repos.",
    "strong"
  ],
  [
    "raison-3",
    "cette étude à également démontrer qu'ils n'ont eux d'effets secondaires, ni de dépendance.",
    "strong"
  ],
  [
    "raison-3",
    "Un essai clinique mené pendant plus de 6 mois.",
    "strong"
  ]
];
  const applyReadingEmphasis = (root) => {
    const article = root.matches?.('article.article') ? root : root.querySelector('article.article');
    if (!article) return;
    rules.forEach(([sectionId, phrase, tag]) => {
      const section = article.querySelector(`#${sectionId}`);
      if (!section) return;
      const paragraphs = [...section.querySelectorAll('.copy p')].filter((paragraph) => paragraph.textContent.includes(phrase));
      if (paragraphs.length !== 1) return;
      const paragraph = paragraphs[0];
      if ([...paragraph.querySelectorAll('strong, b, mark, u')].some((element) => element.textContent === phrase)) return;
      const start = paragraph.textContent.indexOf(phrase);
      const end = start + phrase.length;
      const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
      let node;
      let offset = 0;
      let startNode;
      let startOffset;
      let endNode;
      let endOffset;
      while ((node = walker.nextNode())) {
        const next = offset + node.textContent.length;
        if (!startNode && start >= offset && start < next) {
          startNode = node;
          startOffset = start - offset;
        }
        if (startNode && end > offset && end <= next) {
          endNode = node;
          endOffset = end - offset;
          break;
        }
        offset = next;
      }
      if (!startNode || !endNode) return;
      const range = document.createRange();
      range.setStart(startNode, startOffset);
      range.setEnd(endNode, endOffset);
      const emphasis = document.createElement(tag);
      emphasis.dataset.vfReadingEmphasis = '';
      emphasis.append(range.extractContents());
      range.insertNode(emphasis);
    });
  };
  applyReadingEmphasis(document);
  document.addEventListener('shopify:section:load', (event) => applyReadingEmphasis(event.target));
})();
